import { ObjectsData } from "@organisms/ObjectsView/ObjectsView.types"
import useInfiniteObjectsList from "@organisms/ObjectsView/hooks/useInfiniteObjectsList"
import Table from "@organisms/Table/Table"

import withAlternativeStates from "@HOCs/withAlternativeStates"

import useTableView from "./TableView.context"
import TableViewProvider from "./TableView.provider"
import { TableViewTableProps } from "./TableView.types"
import TableViewEmptyState from "./TableViewEdgeStates/TableViewEmptyState/TableViewEmptyState"
import TableViewErrorState from "./TableViewEdgeStates/TableViewErrorState/TableViewErrorState"
import TableViewHiddenByScheduleHorizonState from "./TableViewEdgeStates/TableViewHiddenByScheduleHorizonState/TableViewHiddenByScheduleHorizonState"
import TableViewLoadingState from "./TableViewEdgeStates/TableViewLoadingState/TableViewLoadingState"
import TableViewNoResultsState from "./TableViewEdgeStates/TableViewNoResultsState/TableViewNoResultsState"

// Feeds the Table organism from the objects view and table view contexts.
function TableViewTable(props: TableViewTableProps) {
    const { children } = props

    const { table } = useTableView<ObjectsData>()
    const listProps = useInfiniteObjectsList()

    return (
        <Table.Table table={table} {...listProps}>
            {children}
        </Table.Table>
    )
}

const TableViewTableWithAlternativeStates = withAlternativeStates<TableViewTableProps>({
    LoadingState: TableViewLoadingState,
    ErrorState: TableViewErrorState,
    EmptyState: TableViewEmptyState,
    NoResultsState: TableViewNoResultsState,
    HiddenByScheduleHorizonState: TableViewHiddenByScheduleHorizonState,
    SuccessState: TableViewTable,
})

export default {
    Provider: TableViewProvider,
    Table: TableViewTableWithAlternativeStates,
}
